import i18n from "@/i18n";
import { LOCALES } from "@/enums/locales";

const locale = localStorage.getItem("locale");

if (locale) {
    i18n.locale = LOCALES[locale];
} else {
    i18n.locale = LOCALES["pt_pt"];
}

const PAGES = {
    SIMULATOR: i18n.t("pagesEnum.simulator"),
    INSTANCE_CHOOSE: i18n.t("pagesEnum.chooseInstance"),
    BACKOFFICE_USERS: i18n.t("pagesEnum.backoffice.users"),
    BACKOFFICE_ENTITIES: i18n.t("pagesEnum.backoffice.entities"),
    BACKOFFICE_USERS_GROUP: i18n.t("pagesEnum.backoffice.usersGroup"),
    BACKOFFICE_USER_DETAIL: i18n.t("pagesEnum.backoffice.userDetails"),
    BACKOFFICE_USER_DETAIL_EDIT: i18n.t("pagesEnum.backoffice.editUserDetails"),
    BACKOFFICE_ENTITY_DETAIL: i18n.t("pagesEnum.backoffice.entityDetails"),
    BACKOFFICE_VIEW_ENTITY_DETAIL: i18n.t("pagesEnum.backoffice.viewEntityDetails"),
    PROPOSAL_LIST_PROPOSAL: i18n.t("pagesEnum.proposals.child.listProposals"),
    PROPOSAL_PAGE: i18n.t("pagesEnum.proposals.child.proposal"),
    COTATION: i18n.t("pagesEnum.cotation"),
    ERROR_PAGE: i18n.t("pagesEnum.errorPage"),
    BACKOFFICE_COMPANY_DETAIL: i18n.t("pagesEnum.backoffice.companyDetails"),
    BACKOFFICE_COMPANY_DETAIL_EDIT: i18n.t("pagesEnum.backoffice.editCompanyDetails"),
    BACKOFFICE_FINANCIAL_DATA_TAEG: i18n.t("pagesEnum.backoffice.financialDataTaeg"),
    BACKOFFICE_FINANCIAL_DATA_ISCD: i18n.t("pagesEnum.backoffice.taxStamp"),
    BACKOFFICE_FINANCIAL_DATA_TRANSVERSAL: i18n.t("pagesEnum.backoffice.transversal"),
    BACKOFFICE_COMPANIES: i18n.t("pagesEnum.backoffice.companies"),
    BACKOFFICE_RATE_SITES: i18n.t("pagesEnum.backoffice.rateOfSites"),
    BACKOFFICE_FINANCIALS: i18n.t("pagesEnum.backoffice.finanacials"),
    BACKOFFICE_FINANCIAL_DETAIL: i18n.t("pagesEnum.backoffice.financeDetails"),
    BACKOFFICE_SITES_FINANCIAL: i18n.t("pagesEnum.backoffice.sitesFinanacial"),
    BACKOFFICE_FINANCIAL_DATA_ISCD_DETAIL: i18n.t("pagesEnum.backoffice.iscd"),
    BACKOFFICE_FINANCIAL_DETAIL_EDIT: i18n.t("pagesEnum.backoffice.editFinanceDetails"),
    BACKOFFICE_FINANCIAL_DETAIL_SPREAD: i18n.t("pagesEnum.backoffice.spreadDetails"),
    BACKOFFICE_FINANCIAL_DETAIL_INSURANCES: i18n.t("pagesEnum.backoffice.insuranceDetails"),

    BACKOFFICE_INSURANCES: i18n.t("pagesEnum.backoffice.insurancePage"),
    BACKOFFICE_FINANCIAL_DETAIL_TIN: i18n.t("pagesEnum.backoffice.tinDetails"),
    BACKOFFICE_FINANCIAL_DETAIL_DISCLAIMER: i18n.t("pagesEnum.backoffice.disclaimerDetails"),
};

export { PAGES };
